/**
 * ES-8947: Fixes a redirect loop when the app is opened
 * with query params but without a hash.
 */
const { search, pathname, hash } = window.location;

if (search) {
    const targetHash = (hash && hash !== "#/") ? hash : "#/welkom";
    window.location.replace(`${pathname}${targetHash}${search}`);
}
